/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from './config';

async function reqLoginCMS() {
	const API_URI_LOGIN = Config.rutasCMS.auth;	
	const params = new URLSearchParams();
	params.append('client_id', process.env.REACT_APP_CLIENT_ID);
	params.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
	params.append('grant_type', process.env.REACT_APP_GRANT_TYPE);
	try {
		const response = await axios.post(API_URI_LOGIN, params, {
			headers: { 'content-type': 'application/x-www-form-urlencoded' }
		});		
		return response.data;
	} catch (error) {		
		return error
	}
}

export default reqLoginCMS; 
